<div class="card mt-4">
  <header class="card-header is-flex is-align-items-center justify-center">
    <div class="pl-4">
      <span
        style="border-right: 1px solid #ededed; width: 80px"
        class="is-inline-block mr-3"
      >
        <strong class="is-size-7" translationEditableDirective="YEAR">{{
          'YEAR' | translate
        }}</strong
        >:
        <span class="is-size-7">{{ payment.dataCycle.year }}</span>
      </span>
      <span
        style="border-right: 1px solid #ededed; width: 180px"
        class="is-inline-block mr-3"
        *ngIf="hasType"
      >
        <strong
          class="is-size-7"
          translationEditableDirective="PROPERTY_TYPE"
          >{{ 'PROPERTY_TYPE' | translate }}</strong
        >:
        <span class="is-size-7">{{ payment.propertyType }}</span>
      </span>
      <span
        style="border-right: 1px solid #ededed; width: 150px"
        class="is-inline-block mr-3"
      >
        <strong
          class="is-size-7"
          translationEditableDirective="TOTAL_PAYABLE"
          >{{ 'TOTAL_PAYABLE' | translate }}</strong
        >:
        <span class="is-size-7"
          >{{ payment.balance.totalPayable }} {{ currency }}</span
        >
      </span>
      <span
        style="border-right: 1px solid #ededed; width: 140px"
        class="is-inline-block mr-3"
      >
        <strong class="is-size-7" translationEditableDirective="TOTAL_PAYED">{{
          'TOTAL_PAYED' | translate
        }}</strong
        >:
        <span class="is-size-7"
          >{{ payment.balance.totalPayed }} {{ currency }}</span
        >
      </span>
      <span style="width: 160px" class="is-inline-block mr-3">
        <strong class="is-size-7" translationEditableDirective="BALANCE">{{
          'BALANCE' | translate
        }}</strong
        >:
        <span
          class="tag"
          [ngStyle]="{
            background: getBalanceColor(payment),
          }"
        >
          {{ payment.balance.balance }} {{ currency }}
        </span>
      </span>
    </div>
    <div class="ml-auto is-flex is-align-items-center">
      <ng-container *ngxPermissionsOnly="['ADD_EDIT_PAYMENT']">
        <button
          *ngIf="isCurrentCycle && !readonly"
          type="button"
          style="margin-left: 10px"
          class="button is-small is-info"
          translationEditableDirective="ADD_PAYMENT"
          (click)="onCreatePayment.emit()"
        >
          {{ 'ADD_PAYMENT' | translate }}
        </button>
      </ng-container>
      <button
        class="card-header-icon ml-2"
        aria-label="see more"
        (click)="open ? onClose.emit() : onOpen.emit()"
      >
        <span class="icon">
          <i
            class="fas"
            [ngClass]="{ 'fa-angle-down': !open, 'fa-angle-up': open }"
            aria-hidden="true"
          ></i>
        </span>
      </button>
    </div>
  </header>
  <div *ngIf="open" class="p-4">
    <div>
      <span class="is-inline-block mr-6">
        <strong class="is-block" translationEditableDirective="REFERENCE_ID">{{
          'REFERENCE_ID' | translate
        }}</strong>
        <span class="is-block">{{ payment.referenceId }}</span>
      </span>
      <span class="is-inline-block mr-6">
        <strong class="is-block" translationEditableDirective="TAX">{{
          'TAX' | translate
        }}</strong>
        <span class="is-block">{{ payment.amount }}</span>
      </span>
      <span class="is-inline-block mr-6">
        <strong class="is-block" translationEditableDirective="ARREARS">{{
          'ARREARS' | translate
        }}</strong>
        <span class="is-block">{{ payment.arrears }} {{ currency }}</span>
      </span>
      <span class="is-inline-block mr-6">
        <strong class="is-block" translationEditableDirective="PENALTY">{{
          'PENALTY' | translate
        }}</strong>
        <span class="is-block">{{ payment.penalty }} {{ currency }}</span>
      </span>
      <span class="is-inline-block mr-6">
        <strong class="is-block" translationEditableDirective="DISCOUNT">{{
          'DISCOUNT' | translate
        }}</strong>
        <span class="is-block">{{ payment.discount }} {{ currency }}</span>
      </span>
      <span
        *ngIf="
          payment.type !== 'BUSINESS_PAYABLE' &&
          payment.type !== 'COMPOUND_PAYABLE'
        "
        class="is-inline-block mr-6"
      >
        <strong
          class="is-block"
          translationEditableDirective="GROUP_DISCOUNT"
          >{{ 'GROUP_DISCOUNT' | translate }}</strong
        >
        <span class="is-block"
          >{{ payment.totalGroupDiscount }} {{ currency }}</span
        >
      </span>
      <span class="is-inline-block">
        <strong class="is-block" translationEditableDirective="TOTAL">{{
          'TOTAL' | translate
        }}</strong>
        <span class="is-block"
          >{{ payment.balance.totalPayable }} {{ currency }}</span
        >
      </span>
    </div>

    <div class="payments-section mt-6">
      <h5>
        <span translationEditableDirective="PAYMENTS">
          {{ 'PAYMENTS' | translate }}
        </span>
      </h5>

      <app-table
        [totalItems]="payments.size"
        [rows]="payments"
        [columns]="columns"
      >
        <ng-template let-row="row" #transactionId>
          <span class="bank-truncate" [title]="row.get('transactionId')">{{
            row.get('transactionId')
          }}</span>
        </ng-template>
        <ng-template let-row="row" #notes>
          <span class="notes-truncate" [title]="row.get('notes')">{{
            row.get('notes')
          }}</span>
        </ng-template>
        <ng-template let-row="row" #tax>
          {{ row.get('amount') }} {{ currency }}
        </ng-template>
        <ng-template let-row="row" #paymentDate>
          {{ row.get('paymentDate') | formatDate }}
        </ng-template>
        <ng-template let-row="row" #actions>
          <div class="is-flex is-align-items-center is-justify-content-end">
            <button
              class="button is-small mr-2"
              (click)="onDownloadPayment.emit(row.toJS())"
              translationEditableDirective="RECIPT"
              [disabled]="isPaymentDownloading"
            >
              {{ 'RECIPT' | translate }}
            </button>

            <ng-container *ngxPermissionsOnly="['ADD_EDIT_PAYMENT']">
              <button
                (click)="onUpdatePayment.emit(row.toJS())"
                class="button is-small mr-2"
                *ngIf="!hasReadonlyPermission && isCurrentCycle && !readonly"
                translationEditableDirective="UPDATE"
              >
                {{ 'UPDATE' | translate }}
              </button>
              <alert
                #deletePaymentAlert
                (confirm)="onDeletePayment.emit(row.toJS())"
                titleTrnKey="ARE_YOU_SURE"
                textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
              />
              <button
                class="button is-danger is-small"
                *ngIf="!hasReadonlyPermission && isCurrentCycle && !readonly"
                (click)="deletePaymentAlert.fire()"
                translationEditableDirective="DELETE"
              >
                {{ 'DELETE' | translate }}
              </button>
            </ng-container>
          </div>
        </ng-template>
      </app-table>
    </div>
  </div>
</div>
